import React from 'react';
import {useTranslation} from "@Translation/hooks/useTranslation";
import IconListWithArrow from "@Icons/IconListWithArrow";
import Row from "@Containers/components/Row";
import {Colors} from "@Styles/Colors.style";

interface TableOfContentsHeaderProps {
    expandToc: boolean,
    callback: any,
}
function TableOfContentsHeader({expandToc, callback}: TableOfContentsHeaderProps) {
    const tocTitle = useTranslation('sys.toc')
    const orientation = (expandToc) ? "up" : "down";

    return (
        <Row onClick={callback} className="gb-toc__title" justify center gap >
            <h2>{tocTitle}</h2>
            <IconListWithArrow fill={Colors.primaryColor} chevronOrientation={orientation}/>
        </Row>
    );
}
export default TableOfContentsHeader;